module.exports = __webpack_public_path__ + "static/img/delivery.83eb07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delivery.png
// module id = 319
// module chunks = 7